export default [
  {
    path: '/sales',
    name: 'SaleOverviews',
    component: () => import('@/views/Sales/Index.vue'),
    meta: {
      pageTitle: 'Sıfır Satış',
      breadcrumb: [
        {
          text: 'Genel Bakış',
          active: true,
        },
      ],
      resource: 'RP_SALES',
      action: 'read',
    },
  },
  {
    path: '/sales/brands',
    name: 'SaleBrands',
    component: () => import('@/views/Sales/Brands.vue'),
    meta: {
      pageTitle: 'Sıfır Satış',
      breadcrumb: [
        {
          text: 'Anlık Satışlar',
          active: true,
        },
      ],
      resource: 'RP_SALES',
      action: 'read',
    },
  },
  {
    path: '/sales/cumulatives',
    name: 'SaleCumulatives',
    component: () => import('@/views/Sales/Cumulatives.vue'),
    meta: {
      pageTitle: 'Sıfır Satış',
      breadcrumb: [
        {
          text: 'Kümülatif',
          active: true,
        },
      ],
      resource: 'RP_SALES',
      action: 'read',
    },
  },
  {
    path: '/sales/sales',
    name: 'SaleCounts',
    component: () => import('@/views/Sales/SaleCounts.vue'),
    meta: {
      pageTitle: 'Sıfır Satış',
      breadcrumb: [
        {
          text: 'Satışlar',
          active: true,
        },
      ],
      resource: 'RP_SALES',
      action: 'read',
    },
  },
  {
    path: '/sales/swaps',
    name: 'SaleSwaps',
    component: () => import('@/views/Sales/SwapSales.vue'),
    meta: {
      pageTitle: 'Sıfır Satış',
      breadcrumb: [
        {
          to: '/sales',
          text: 'Sıfır Satış',
        },
        {
          text: 'Takaslar',
          active: true,
        },
      ],
      resource: 'RP_SALES',
      action: 'read',
    },
  },
  {
    path: '/sales/insurances',
    name: 'SaleInsurances',
    component: () => import('@/views/Sales/Insurance.vue'),
    meta: {
      pageTitle: 'Sıfır Satış',
      breadcrumb: [
        {
          to: '/sales',
          text: 'Sıfır Satış',
        },
        {
          text: 'Sigorta',
          active: true,
        },
      ],
      resource: 'RP_SALES',
      action: 'read',
    },
  },
  {
    path: '/sales/connections',
    name: 'SaleConnections',
    component: () => import('@/views/Sales/Connections.vue'),
    meta: {
      pageTitle: 'Sıfır Satış',
      breadcrumb: [
        {
          to: '/sales',
          text: 'Sıfır Satış',
        },
        {
          text: 'Bağlantılar',
          active: true,
        },
      ],
      resource: 'RP_SALES',
      action: 'read',
    },
  },
  {
    path: '/sales/stocks',
    name: 'SaleStocks',
    component: () => import('@/views/Sales/Stocks.vue'),
    meta: {
      pageTitle: 'Sıfır Satış',
      breadcrumb: [
        {
          to: '/sales',
          text: 'Sıfır Satış',
        },
        {
          text: 'Stoklar',
          active: true,
        },
      ],
      resource: 'RP_SALES',
      action: 'read',
    },
  },
  {
    path: '/sales/interviews',
    name: 'SaleInterview',
    component: () => import('@/views/Sales/Interviews.vue'),
    meta: {
      pageTitle: 'Sıfır Satış',
      breadcrumb: [
        {
          to: '/sales',
          text: 'Sıfır Satış',
        },
        {
          text: 'Görüşmeler',
          active: true,
        },
      ],
      resource: 'RP_SALES',
      action: 'read',
    },
  },
  {
    path: '/sales/customers',
    name: 'SaleCustomers',
    component: () => import('@/views/Sales/Customers.vue'),
    meta: {
      pageTitle: 'Sıfır Satış',
      breadcrumb: [
        {
          to: '/sales',
          text: 'Sıfır Satış',
        },
        {
          text: 'Müşteriler',
          active: true,
        },
      ],
      resource: 'RP_SALES',
      action: 'read',
    },
  },
  {
    path: '/sales/goals',
    name: 'SaleGoals',
    component: () => import('@/views/Sales/Goals.vue'),
    meta: {
      pageTitle: 'Sıfır Satış',
      breadcrumb: [
        {
          to: '/sales',
          text: 'Sıfır Satış',
        },
        {
          text: 'Hedef Gerçekleştirme',
          active: true,
        },
      ],
      resource: 'RP_SALES',
      action: 'read',
    },
  },
]
